// extracted by mini-css-extract-plugin
module.exports = {"logo":"HeaderLogo-module--logo--zMsER","is_opened":"HeaderLogo-module--is_opened--3hfsu","is_scrolled":"HeaderLogo-module--is_scrolled--2x61C"};